require('./bootstrap');

import './modules/search';
import './modules/cars-list';
import './modules/car-page';
import './modules/index';

$(document).ready(function () {
  $('.select2').select2();

  $('[data-toggle="tooltip"]').tooltip({
    html: true,
    placement: "bottom"
  })


  $('.go-to-top').scrollToTop(1000);
  //$("#menu").mmenu();

  // /********** Mobeil Menu **************/
  // $('#mobile-menu').show();
  // var menuAPI = $('#mobile-menu').mmenu({
  //         extensions: [
  //             "position-back",
  //             "position-right"
  //         ]
  // }).data("mmenu");
  //
  // menuAPI.bind('close:finish', function() {
  //     $('.hamburger').removeClass('is-active');
  // });
  // menuAPI.bind('open:finish', function () {
  //     $('.hamburger').addClass('is-active');
  // });
  // $('.hamburger').on('click', function (e) {
  //     e.preventDefault();
  //     menuAPI.open();
  // });

  if ($('.swiper-thumb').length > 0) {
    var swiper = new Swiper(".swiper-thumb", {
      // loop: true,
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          spaceBetween: 10,
          slidesPerView: 5,
        },
      },
    });

  }
  if ($('.swiper-view').length > 0) {
    var swiper2 = new Swiper(".swiper-view", {
      // loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }

  if ($('.slider-oferte').length > 0) {
    $('.slider-oferte').slick({
      centerMode: true,
      centerPadding: '120px',
      slidesToShow: 3,
      arrows: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 769,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
    });
  }

  $(document).on('click', '.open-mobile-menu-btn', function () {
    openNav();
  });
  $(document).on('click', '.close-mobile-menu-btn', function () {
    closeNav();
  });
  $(document).on('click', '.filtersBtn', function () {
    openFilters();
  });
  $(document).on('click', '.closeFilters', function () {
    closeFilters();
  });
});

(function (a) {
  a.fn.scrollToTop = function (c) {
    var d = {
      speed: 800
    };
    c && a.extend(d, {
      speed: c
    });
    return this.each(function () {
      var b = a(this);
      a(window).scroll(function () {
        100 < a(this).scrollTop() ? b.fadeIn() : b.fadeOut()
      });
      b.click(function (b) {
        b.preventDefault();
        a("body, html").animate({
          scrollTop: 0
        }, d.speed)
      })
    })
  }
})(jQuery);

function openNav() {
  document.getElementById("menuMobile").style.width = "250px";
  $("body").css("overflow", "hidden");
  $(".overlay-mobile-menu").addClass("opened");
}

function closeNav() {
  document.getElementById("menuMobile").style.width = "0";
  $("body").css("overflow-y", "scroll");
  $(".overlay-mobile-menu").removeClass("opened");
}

function openFilters() {
  document.getElementById("filtersCars").style.width = "250px";
  $("body").css("overflow", "hidden");
  $(".overlay-mobile-menu").addClass("opened");
}

function closeFilters() {
  document.getElementById("filtersCars").style.width = "0";
  $("body").css("overflow-y", "scroll");
  $(".overlay-mobile-menu").removeClass("opened");
}

$(document).ready(function () {
  $(".overlay-mobile-menu").click(function () {
    if ($(this).hasClass("opened")) {
      $("#menuMobile").css("width", "0");
      $("#filtersCars").css("width", "0");
      $(".overlay-mobile-menu").removeClass("opened");
    }
  });


  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
    focusOnSelect: true
  });


  $(".read-more-btn-car").click(function () {
    $(".read-more-content").slideToggle(".show");
    $(".gradient").toggleClass("yes-gradient");
    $(this).hide();
    $(".read-less-btn-car").show();
  });

  $(".read-less-btn-car").click(function () {
    $(this).hide();
    $(".read-more-btn-car").show();
    $(".read-more-content").slideToggle(".hide");
    $(".gradient").toggleClass("yes-gradient");
  });

  $('.multiple-items').slick({
    infinite: true,
    slidesToShow: 4,
    arrows: true,
    dots: false,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

});

$(".filter").click(function () {
  $(".opened-filters").addClass("opened");
  $(".overlay-desktop-filters").addClass("opened");
});


$(document).mouseup(function (e) {

  var container = $(".opened-filters");

  if (!container.is(e.target) && container.has(e.target).length === 0) {

    container.removeClass("opened");
    $(".overlay-desktop-filters").removeClass("opened");
  }
});

////////////SCROLL DESKTOP APARE UN HEADER FIX////////////////////
function handleDesktopHeaderScroll() {
  // rulează doar dacă fereastra e peste 1025px
  if ($(window).width() >= 1025) {
    $(window).on('scroll.headerDesktop', function () {
      if ($(this).scrollTop() > 0) {
        $('.header.desktop').addClass('fixed');
        $('.banner-home .wrap-content').addClass('opened-header');
        $('.carPage .car-details-hide .sticky-top').addClass('is-stuck');
      } else {
        $('.header.desktop').removeClass('fixed');
        $('.banner-home .wrap-content').removeClass('opened-header');
        $('.carPage .car-details-hide .sticky-top').removeClass('is-stuck');
      }
    });
  } else {
    // dacă revenim sub 1025px, scoatem eventul și clasele
    $(window).off('scroll.headerDesktop');
    $('.header.desktop').removeClass('fixed');
  }
}

////////////SCROLL DESKTOP APARE UN HEADER FIX END////////////////////


////////////SCROLL MOBIL APARE UN HEADER FIX////////////////////

// rulează la load și la resize
$(function () {
  handleDesktopHeaderScroll();
  $(window).on('resize', handleDesktopHeaderScroll);
});



function getScrollY() {
  return window.pageYOffset !== undefined
    ? window.pageYOffset
    : (document.documentElement || document.body).scrollTop;
}

function handleScrollBehavior() {
  const width = $(window).width();
  const $window = $(window);

  // eliminăm orice evenimente anterioare (pentru a evita dublarea la resize)
  $window.off('.headerScroll');

  if (width >= 1025) {
    // --- DESKTOP ---
    $window.on('scroll.headerScroll', function () {
      if (getScrollY() > 0) {
        $('.header.desktop').addClass('fixed');
      } else {
        $('.header.desktop').removeClass('fixed');
      }
    });
  } else {
    // --- MOBILE / TABLETĂ ---
    $window.on('scroll.headerScroll touchmove.headerScroll', function () {
      if (getScrollY() > 0) {
        $('.header-mobile .scrolling-header').addClass('opened');
        $('.banner-home .wrap-content').addClass('opened-header');
      } else {
        $('.header-mobile .scrolling-header').removeClass('opened');
        $('.banner-home .wrap-content').removeClass('opened-header');
      }
    });
  }
}

// rulează la load și resize
$(function () {
  handleScrollBehavior();
  $(window).on('resize', handleScrollBehavior);

  // rulează și o dată la încărcare (în caz că intri deja scrollat)
  if (getScrollY() > 0) {
    handleScrollBehavior();
  }
});

////////////SCROLL MOBIL APARE UN HEADER FIX END////////////////////


// WEBPACK FOOTER //
// ./resources/assets/js/app.js